import { FC, useEffect, useState } from "react";
import LicenseChangeTable from "./LicenseChangeTable";
import CustomPagination from "../../common/CustomPagination";
import LicenseForm from "./LicenseForm";
import { Company } from "../../data/interfaces/company";
import { LicenseChange } from "../../data/interfaces/licenseChange";
import DeactivateReactivateButton from "../deactivate-reactivate/DeactivateReactivateButton";
import { DeactivateCompanyRequest } from "../../data/interfaces/DeactivateCompanyRequest";
import { ReactivateCompanyRequest } from "../../data/interfaces/ReactivateCompanyRequest";

interface Props {
  company: Company | undefined;
  licenseChanges: LicenseChange[];
}

const Dealer: FC<Props> = ({ company, licenseChanges }) => {
  const [list, setList] = useState<LicenseChange[]>([]);

  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize] = useState(5);

  const endIndex: number = pageNumber * pageSize;
  const startIndex: number = endIndex - pageSize;
  const currentPage: LicenseChange[] = list.slice(startIndex, endIndex);
  const lastPage: number = Math.ceil(licenseChanges.length / pageSize);
  const disablePrevious: boolean = pageNumber === 1 ? true : false;
  const disableNext: boolean = currentPage.length < pageSize ? true : false;

  useEffect(() => {
    setList(licenseChanges);
  }, [licenseChanges]);

  const next = () => {
    let nextPageNumber = pageNumber + 1;

    setPageNumber(nextPageNumber);
  };

  const previous = () => {
    let previousPageNumber = pageNumber - 1;
    setPageNumber(previousPageNumber);
  };

  const deactivatedCompany: DeactivateCompanyRequest = {
    companyId: company?.companyId || 0,
    companyName: company?.companyName || "",
    accountNumber: company?.accountNumber.toString() || "",
    changedBy: "",
    reason: ""
  };

  const reactivatedCompany: ReactivateCompanyRequest = {
    companyId: company?.companyId || 0,
    changedBy: "",
    reason: ""
  };

  return (
    <div className="d-flex flex-column justify-content-around">
      <div className="m-1 p-1">
        <h2 className="display-6 mb-4 mt-3">{company?.companyName} - {company?.accountNumber}</h2>
        <DeactivateReactivateButton
          companyId={Number(company?.companyId)}
          isActive={Boolean(company?.isActive)}
          deactivatedCompany={deactivatedCompany}
          reactivatedCompany={reactivatedCompany}
        />        
        <LicenseForm company={company} />
        <LicenseChangeTable licenseChanges={currentPage} />
        <CustomPagination
          nextPage={next}
          previousPage={previous}
          currentPage={pageNumber}
          lastPage={lastPage}
          disableNextButton={disableNext}
          disablePreviousButton={disablePrevious}
        />
      </div>
    </div>
  );
};

export default Dealer;
